import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { useRightDrawerStore } from "@/store/rightDrawer"; // Import the preferences store
import preferencesAPI from '@/api/preferences'; // Import the carListings API module

interface ColumnPreference {
    title: string;
    value: string;
    format: string;
    sortable: boolean;
  }

export const usePreferencesStore = defineStore('preferences', () => {
    const preferences = ref<Record<string, { headers?: { data: any[] } }>>({});
    const allModuleHeaders = ref<ColumnPreference[]>([]); // Stores all headers for all modules as a single array
    const defaultModuleHeaders = ref<ColumnPreference[]>([]); // Stores all headers for all modules as a single array
    const rightDrawerStore = useRightDrawerStore();
    const currentModule = ref<string>(''); // ✅ Change computed to ref()
    const userPreferenceModuleHeaders = computed(() => {
        return preferences.value?.[currentModule.value]?.headers?.data || [];
    });


    const setPreferences = (newPreferences: Record<string, { headers?: { data: any[] } }>) => {
      console.log("Updating preferences:", newPreferences);
      preferences.value = newPreferences;
  };
    

  // Load preferences from local storage
  const loadPreferences = () => {
    const storedPreferences = localStorage.getItem('preferences');
    if (storedPreferences) {
      preferences.value = JSON.parse(storedPreferences);
    }
  };

  // Save preferences to local storage
  const savePreferences = async (headers: any[]) => {
    if (!currentModule.value) return;

    const payload: any = [];

    if (headers && headers.length > 0) {
        const headersArray = [
            ['module', currentModule.value],
            ['subject', 'headers'],
            ['data', headers]
        ];
        payload.push(Object.fromEntries(headersArray));
    }

    try {
        const response = await preferencesAPI.createPreference(payload);
        
        if (response.data) {
            console.log("Preferences saved successfully:", response.data);

            // ✅ Update preferences state when the API call is successful
            preferences.value = response.data

            // ✅ Store in localStorage
            localStorage.setItem('preferences', JSON.stringify(preferences.value));

            rightDrawerStore.closeDrawer();
        } else {
            console.error("Failed to save preferences:", response);
        }
    } catch (error) {
        console.error("Error saving preferences:", error);
    }

    console.log("Payload sent:", payload);
};



  // Update preferences for a specific module
  /*const updatePreferences = (module: string, updatedColumns: ColumnPreference[]) => {
    preferences.value[module] = updatedColumns;
    savePreferences();
  };*/

  const setAllModuleHeaders = (headers: ColumnPreference[]) => {
    allModuleHeaders.value = headers;
  };

  const setDefaultModuleHeaders = (headers: ColumnPreference[]) => {
    defaultModuleHeaders.value = headers
  };
  

  return {
    preferences,
    setPreferences,
    loadPreferences,
    savePreferences,
    //updatePreferences,
    allModuleHeaders,
    defaultModuleHeaders,
    userPreferenceModuleHeaders,
    setAllModuleHeaders,
    setDefaultModuleHeaders,
    //setUserPreferenceModuleHeaders,
    currentModule
  };
});